import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree,Router } from '@angular/router';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  private readonly TOKEN_NAME = 'flex_auth';
  private headers: HttpHeaders;
  constructor(private router: Router) {
    this.headers = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Access-Control-Allow-Origin', '*');
    setInterval(function(){ 
      let pasa = false;
      let data = localStorage.getItem(this.TOKEN_NAME);
      const expiret = localStorage.getItem('expire');
      if(data != null && expiret != null){
        let expirein = new Date(expiret);
        pasa = (expirein > new Date());
        if(!pasa){
          window.location.href = "/";
        }
      }
     }, 5000);
  }

  redirect(flag:boolean):any{
    if(!flag){
      this.router.navigate(['account','login']);
    }
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      return this.evaluaLogin();
  }
  evaluaLogin(){
    let pasa = false;
    let data = JSON.parse(localStorage.getItem(this.TOKEN_NAME));
    const expiret = localStorage.getItem('expire');
    if(data != null && expiret != null){
      let expirein = new Date(expiret);
      pasa = (expirein > new Date());
    }
    this.redirect(pasa);
    return pasa;
  }
}